<template>
  <!--get a game's score-->
  <div class="scoreboard">
    <div
      class="flex-container top-team"
      v-bind:class="{ 'winning-team': teamOneWon, 'losing-team': !teamOneWon }"
    >
      <img :src="getImageUrl(teamOne)" />
      <div class="score">{{teamOneScore}}</div>
    </div>
    <div
      class="flex-container"
      v-bind:class="{ 'winning-team': teamTwoWon, 'losing-team': !teamTwoWon }"
    >
      <img :src="getImageUrl(teamTwo)" />
      <div class="score">{{teamTwoScore}}</div>
    </div>
    <!--TODO: Add venue below score-->
  </div>
</template>

<script>
export default {
  name: "GameScore",
  teamOneWon: Boolean,
  teamTwoWon: Boolean,
  props: {
    teamOne: String,
    teamOneScore: Number,
    teamTwo: String,
    teamTwoScore: Number
  },
  methods: {
    getTeamName(teamName) {
      var teamConversions = {
        ARI: "Diamondbacks",
        ATL: "Braves",
        BAL: "Orioles",
        BOS: "Red Sox",
        CHC: "Cubs",
        CWS: "White Sox",
        CIN: "Reds",
        CLE: "Indians",
        COL: "Rockies",
        DET: "Tigers",
        HOU: "Astros",
        KC: "Royals",
        LAA: "Angels",
        LAD: "Dodgers",
        MIA: "Marlins",
        MIL: "Brewers",
        MIN: "Twins",
        NYM: "Mets",
        NYY: "Yankees",
        OAK: "Athletics",
        PHI: "Phillies",
        PIT: "Pirates",
        SD: "Padres",
        SEA: "Mariners",
        SF: "Giants",
        STL: "Cardinals",
        TB: "Rays",
        TEX: "Rangers",
        TOR: "Blue Jays",
        WAS: "Nationals"
      };
      return teamConversions[teamName];
    },
    getImageUrl(teamName) {
      var images = require.context("../assets/", false, /\.png$/);
      var convertedTeamName = this.getTeamName(teamName);
      return images("./" + convertedTeamName + ".png");
    },
    setWins() {
      this.teamOneWon = this.teamOneScore > this.teamTwoScore;
      this.teamTwoWon = this.teamTwoScore > this.teamOneScore;
    }
  },
  beforeMount() {
    this.setWins();
  }
};
</script>

<style scoped>
.scoreboard {
  width: 300px;
  height: 40vh;
  overflow: hidden;
  border: 2px solid black;
  margin: 2.5vw;
}
.score {
  float: right;
  top: 0;
  bottom: 0;
}
img {
  max-width: 40%;
  max-height: 70%;
  padding: 2%;
}

.flex-container {
  height: 20vh;
  justify-content: space-around;
  display: flex;
  align-items: center;
}

.flex-container > img {
  justify-content: left;
}

.top-team {
  border-bottom: 2px solid black;
}

.losing-team {
  background-color: lightgray;
}

.winning-team {
  background-color: gray;
}

.flex-container > div {
  background-color: #f1f1f1;
  font-size: 5em;
  width: 40%;
  justify-content: right;
}
</style>
